import { useState } from 'react';

const STORAGE_KEY = 'silos_detail_display';

function getDefaultMode() {
  if (typeof window === 'undefined') return 'aside';
  return window.innerWidth < 768 ? 'modal' : 'aside';
}

export function useDetailPreference() {
  const [mode, setMode] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) ?? getDefaultMode();
    } catch {
      return getDefaultMode();
    }
  });

  const changeMode = (newMode) => {
    try {
      localStorage.setItem(STORAGE_KEY, newMode);
    } catch {}
    setMode(newMode);
  };

  return { mode, changeMode };
}
